export const styles = {
  container: {
    borderRadius: 2,
  },
  content: {
    paddingInline: 24,
    paddingBlock: 24,
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'right',
    paddingLeft: 74,
    paddingRight: 10,
    paddingBottom: 10,
  },
};
